package gr.tech.GRAttestation.models.user.auth

import kotlinx.serialization.Serializable

@Serializable
data class PasswordResetModel(
    val newPassword: String = "",
    val confirmedPassword: String = "",
    val resetToken: String = ""
)